/**
 * Created by OBL on 14/01/2016.
 */
define('superAdminMbAModelsController',[
    'module',
    'underscore',
    'app',
    'superAdminMbAModelsView',
    'bootbox',
    'mbAModelCreateEditLayoutView',
    'settings',
    'entities/mbamodels'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminMbAModelListController = {
        showMbAModelList: function(data) {
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'mbamodel:delete', _.bind(this.onDelete, this));
            App.regions.getRegion('main').currentView.getRegion('content').show(view);
        },

        showMbAModelAdd: function() {
            this.createEditView = new CreateEditLayoutView({
                mbamodelModel: App.request('mbamodel:model'),
                newItem: true
            });
            this.createEditView.show({
                title: _.i18n('mbamodel.new')
            });
        },

        onGridLoaded: function() {
            var data = {
                url: App.request('mbamodel:get-collection-url'),
                rowCountUrl: App.request('mbamodel:get-count-url')
            };

            this.view.displayGrid(data);
        },

        onDelete: function(secId){
            bootbox.confirm(_.i18n('mbamodel.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('mbamodel:delete', secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminMbAModelListController;
});
